import { useEffect, useState } from 'react'

export interface TimeLeft {
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number): string => String(value).padStart(2, '0')

export function useCountdown(totalSeconds: number): TimeLeft {
  const [remaining, setRemaining] = useState(totalSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
